import { useCallback } from "react";
import { BVHIRoute, CompleteNavigationConfig } from "../config/navigation";

export const useRouteConfig = () => {
  const getBVHIRouteForPath = useCallback((path: string): BVHIRoute | null => {
    const item = CompleteNavigationConfig.find((element) => element.path === path);
    if (item) return item;
    return null;
  }, []);

  const getBVHIRouteForId = useCallback((id: string): BVHIRoute | null => {
    const item = CompleteNavigationConfig.find((element) => element.id === id);
    if (item) return item;
    return null;
  }, []);

  return { getBVHIRouteForPath, getBVHIRouteForId };
};
